import { Tag } from 'antd';

const BulkStatusTag = ({ value, labels }) => {
  if (!value) {
    return '—';
  }

  const { label, color } = labels[value] ?? { label: value, color: 'default' };

  return <Tag color={color}>{label}</Tag>;
};

export default BulkStatusTag;
